import React from 'react';
import { useSubmissionsContext } from '../../context/submissions';
import { ChevronDownIcon } from '../icons/icons';

const SubmissionsTableHead = ({
  headings = [],
  headingClass = '',
  headClass = '',
}) => {
  const { hiddenColumns, sortingCriteria, setSortingCriteria } = useSubmissionsContext();

  const updateSortingCriteria = (field) => {
  setSortingCriteria((prev) => {
    const isSameField = prev.sortBy === field;
    const newSortOrder = isSameField && prev.sortOrder === 1 ? -1 : 1; // 1 for asc, -1 for desc
    const newSortBy = { sortBy: field, sortOrder: newSortOrder };
    return newSortBy;
  });
};

const renderHeadingLabel = (heading) => {
  if (heading.sortable) {
    const isSortedField = sortingCriteria.sortBy === heading.name.toLowerCase();
    const isDescending = sortingCriteria.sortOrder === -1;

    return (
      <button
        type="button"
        onClick={() => updateSortingCriteria(heading.name.toLowerCase())}
        className="hover:text-primary-light group outline-none whitespace-nowrap">
        <span>{heading.label}</span>
        <span className="ml-0.5 xl:ml-2">
          <ChevronDownIcon
            className={`inline transition-all duration-300 text-primary-light ${
              isSortedField ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
            } ${isSortedField && isDescending ? 'rotate-180' : ''}`}
          />
        </span>
      </button>
    );
  }

  return <span>{heading.label}</span>;
};

  const renderHeadings = () =>
    headings.map((heading, index) => {
      if (!hiddenColumns?.includes(heading?.label)) {
        return (
          <th
            scope="col"
            key={heading.name + index}
            className={`whitespace-nowrap pr-4 py-4 text-xs lg:text-xs xl:text-sm font-semibold text-slate-300 text-start font-inter ${headingClass} ${heading.customHeadingClass}`}>
            {renderHeadingLabel(heading)}
          </th>
        );
      }
      return null;
    });

  return (
    <thead className={`bg-[#F2F4F70D] ${headClass}`}>
      <tr>{renderHeadings()}</tr>
    </thead>
  );
};

export default SubmissionsTableHead;
